module.exports = __webpack_public_path__ + "static/media/hotelBanner2.ecf7e7f9.png";